export interface JobCodingRequest {
  id: string;
  requestDate: Date;
  jobNumber: string;
  fiscalYear: number;
  afmJobName: string;
  requester: string;
}
